export const SET_CONFIG = 'setConfig';
export const SET_SELECTIONS = 'setSelections';
export const SET_GATING_COMPLETE = 'setGatingComplete';
export const SET_IP_GATING_COMPLETE = 'setIpGatingComplete';
export const SET_DOCUMENT_GENERATED = 'setDocumentGenerated';
export const SET_DOCUMENT_FILEPATH = 'setDocumentFilepath';
export const SET_COUNTERPARTY = 'setCounterparty';
export const CLEAR_FAST_TRACK_REDUX_STORE = 'clearFastTrackReduxStore';
